import styled, { css } from "styled-components";

export const TaskItemGridWrapper = styled.div`

  list-style: none;
  width: 100%;

  ${({ hideOnMobile }) =>
    hideOnMobile &&
    css`
      display: none;
    `}

  @media screen and (min-width: 1128px) {
    display: list-item;
    max-width: 260px;
  }
`;

export const TaskItemTitleWrapper = styled.div`
  text-align: left;
  font-size: 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--spacingS);
  gap: var(--spacingXs);
  background-color: var(--gray100);
  border-radius: var(--radiusL);
  > img {
    width: 40px;
    aspect-ratio: 1/1;
    object-fit:cover;
  }

  @media screen and (min-width: 1128px) {
    padding: 28px 16px;
  }
`;

export const TitleWrapper = styled.div`
  width: 100%;
  height: auto;
  word-break: break-word;

  > h3 {
    margin: 0;
    font-size: var(--textM);
    color: var(--primary800);
    font-weight: normal;
  }

`;

export const DescriptionWrapper = styled.div`
  color: var(--gray);
  font-size: var(--textS);
  line-height: var(--lineHeightS);
  padding: 0px;
  margin: 0px;

  ul {
    gap: 0;
  }

  > div > p {
    padding: 0px;
    margin: 0px;
  }

`;

export const TaskItemWrapper = styled.article`
  display: flex;
  gap: var(--spacingS);
  list-style: none;
  width: 100%;
  border-radius: 16px;
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
  flex-direction: column;
  text-decoration: none;
  transition: transform 0.1s ease-in-out;
  text-decoration: none;

`;
